import styled from 'styled-components';
import LazyImg from '../../LazyImg';

export const StyledLogo = styled(LazyImg)`
  width: 100%;
  height: 100%;

  // Required for insetWhiteBorder to display on img
  position: relative;
  z-index: -1;
`;
